import { render } from "./StaffList.vue?vue&type=template&id=50664a78&ts=true"
import script from "./StaffList.vue?vue&type=script&lang=tsx"
export * from "./StaffList.vue?vue&type=script&lang=tsx"

import "./StaffList.vue?vue&type=style&index=0&id=50664a78&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__